import type { Student } from '../types';

/** True when an existing student record has the fields required to create a booking without re-prompting. */
export function isStudentProfileCompleteForBooking(student: Student): boolean {
  if (!student.dateOfBirth || !student.gender || !student.skillLevel) return false;
  const dob =
    student.dateOfBirth instanceof Date
      ? student.dateOfBirth
      : new Date(student.dateOfBirth);
  return !Number.isNaN(dob.getTime());
}
